import React, { useState, useEffect } from 'react';
import { useAuthStore } from '../stores/authStore';

const ProtectedVideo = ({ uuid, className, controls = true, autoPlay = false }) => {
  const { accessToken, guestToken } = useAuthStore();
  const [videoSrc, setVideoSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const token = accessToken || guestToken;

    if (!uuid || !token) {
      setLoading(false);
      return;
    }

    const fetchVideo = async () => {
      try {
        setLoading(true);
        setError(false);

        const response = await fetch(`/api/media/${uuid}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to load video');
        }

        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        setVideoSrc(objectUrl);
      } catch (err) {
        console.error('Failed to load protected video:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchVideo();

    // Cleanup object URL on unmount
    return () => {
      if (videoSrc) {
        URL.revokeObjectURL(videoSrc);
      }
    };
  }, [uuid, accessToken, guestToken]);

  if (loading) {
    return (
      <div className={`bg-gray-200 dark:bg-gray-700 animate-pulse flex items-center justify-center ${className}`}>
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (error || !videoSrc) {
    return (
      <div className={`bg-gray-300 dark:bg-gray-600 flex items-center justify-center ${className}`}>
        <svg className="w-16 h-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
    );
  }

  return (
    <video
      src={videoSrc}
      controls={controls}
      autoPlay={autoPlay}
      className={className}
    >
      Your browser does not support video playback.
    </video>
  );
};

export default ProtectedVideo;
